module.exports = __webpack_public_path__ + "img/business-strategy-success-target-goals.9dc6ba35.jpg";